import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';

interface ParsedToolOutput {
  type?: string;
  status?: string;
  message?: string;
  [key: string]: any;
}

interface ToolRendererProps {
  toolName: string;
  output: ParsedToolOutput;
  isLoading?: boolean;
}

export const RatingsRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Analyzing ratings...
      </div>
    );
  }

  const ratings = output.ratings || output.data || [];
  if (Array.isArray(ratings) && ratings.length > 0) {
    return (
      <div
        css={css`
          margin: ${spacing.centi} 0 0 0;
        `}
      >
        {ratings.slice(0, 6).map((rating: any, index: number) => (
          <div
            key={index}
            css={css`
              display: flex;
              justify-content: space-between;
              margin-bottom: ${spacing.centi};
              font-size: 14px;
              line-height: 1.4;
            `}
          >
            <span
              css={css`
                color: ${colors.silver};
              `}
            >
              {rating.category || rating.metric || 'Rating'}
            </span>
            <span
              css={css`
                color: ${rating.rating === 'EXCEPTIONAL'
                  ? colors.leaf
                  : rating.rating === 'FAVORABLE'
                    ? colors.petrolBlue
                    : rating.rating === 'AVERAGE'
                      ? colors.silver
                      : rating.rating === 'UNFAVORABLE'
                        ? colors.earth
                        : rating.rating === 'DANGEROUS'
                          ? colors.berry
                          : colors.silver};
                font-weight: 500;
              `}
            >
              {rating.rating || 'N/A'}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      css={css`
        font-size: 14px;
        color: ${colors.silver};
      `}
    >
      Ratings analysis completed
    </div>
  );
};
